import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ChatMetadata } from "../types/api-types";
import { Message } from "@ai-sdk/react";

interface Options {
    enabled?: boolean;
}

interface Data {
    messages: Message[];
    metadata: ChatMetadata | null;
}

export function useGetChatQuery(chatId: string | null, options?: Options) {
    return useQuery({
        queryKey: ["chat", chatId, "messages"],
        queryFn: async (): Promise<Data> => {
            if (chatId === null) {
                return {
                    messages: [],
                    metadata: null,
                };
            }
            const res = await apiClient.getChat({
                params: {
                    chatId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Error fetching chat");
            }

            return {
                messages: res.body.data.messages as Message[],
                metadata: {
                    id: chatId,
                    createdAt: new Date(res.body.data.createdAt),
                    title: res.body.data.title,
                    type: res.body.data.type,
                    context: res.body.data.context,
                },
            };
        },
        enabled: options?.enabled,
    });
}
